import { Inject, Injectable } from '@angular/core';
import { AuthServiceInterface } from './auth-service.interface';
import { Router } from '@angular/router';
import { UserResponse } from './responses/user.response';
import { Observable, of } from 'rxjs';
import { mergeMap, take, catchError, tap } from 'rxjs/operators';
import { BrowserWindowRef } from '../window/window.service';
import { RbacRolesConstant } from '../rbac/rbac-roles.constant';
import { RbacServiceInterface } from '../rbac/rbac-service.interface';

@Injectable()
export class UserResolverService {
  constructor(
    @Inject('AuthServiceInterface') private authService: AuthServiceInterface,
    @Inject(BrowserWindowRef) private window: BrowserWindowRef,
    @Inject('RbacServiceInterface') public rbacService: RbacServiceInterface,
    private router: Router
  ) {}

  resolve(): Observable<UserResponse> {
    const userData = this.authService.userData();
    const logout = () => {
      this.authService.logout();
      this.router.navigate(['/auth/signin'], { queryParams: { logout: true } });
    };
    if (userData) {
      if (this.rbacService.isRole(RbacRolesConstant.AFFILIATE)) {
        const token = localStorage.getItem('tracking-token');
        this.window.nativeWindow.location.href = `/affiliates/auth/signin?token=${token}`;
      }
      return of(userData);
    } else {
      return this.authService.getUser().pipe(
        take(1),
        mergeMap((user) => {
          if (user) {
            if (this.rbacService.isRole(RbacRolesConstant.AFFILIATE, user)) {
              const token = localStorage.getItem('tracking-token');
              this.window.nativeWindow.location.href = `/affiliates/auth/signin?token=${token}`;
            }
            return of(user);
          } else {
            return of(null).pipe(tap(logout));
          }
        }),
        catchError(() => {
          return of(null).pipe(tap(logout));
        })
      );
    }
  }
}
